'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import {
  BookOpen,
  MessageCircle,
  Search,
  BookText,
  Network,
  Map,
  Clock,
  Sparkles,
} from 'lucide-react';

const NAV_ITEMS = [
  { href: '/', label: 'Home', icon: BookOpen },
  { href: '/chat', label: 'Chat', icon: MessageCircle },
  { href: '/search', label: 'Search', icon: Search },
  { href: '/reader', label: 'Reader', icon: BookText },
  { href: '/graph', label: 'Graph', icon: Network },
  { href: '/map', label: 'Map', icon: Map },
  { href: '/timeline', label: 'Timeline', icon: Clock },
  { href: '/universe', label: 'Universe', icon: Sparkles },
];

export default function Navigation() {
  const pathname = usePathname();

  return (
    <nav
      className="fixed left-0 top-0 h-full z-50 flex flex-col py-4 group transition-all duration-300 w-16 hover:w-60 overflow-hidden"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderRight: '1px solid rgba(200, 164, 94, 0.1)',
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 mb-8 min-w-0">
        <BookOpen
          size={28}
          className="shrink-0"
          style={{ color: 'var(--accent-gold)' }}
        />
        <span
          className="text-lg font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{ color: 'var(--text-primary)' }}
        >
          BibleLLM
        </span>
      </div>

      {/* Nav links */}
      <div className="flex flex-col gap-1 px-2 flex-1">
        {NAV_ITEMS.map(({ href, label, icon: Icon }) => {
          const isActive =
            href === '/' ? pathname === '/' : pathname.startsWith(href);

          return (
            <Link
              key={href}
              href={href}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 min-w-0"
              style={{
                backgroundColor: isActive
                  ? 'rgba(200, 164, 94, 0.12)'
                  : 'transparent',
                color: isActive
                  ? 'var(--accent-gold)'
                  : 'var(--text-secondary)',
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor =
                    'rgba(200, 164, 94, 0.06)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
            >
              <Icon size={20} className="shrink-0" />
              <span className="text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
